<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-videos-left-pane">
      <div class="bmw-lg-videos-left-pane-nav-links">
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["home"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='home'),'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='home')}">
            <div class="col-lg-1 bmw-no-gutter">
              <i class="material-icons dp48">home</i>
            </div>
            <div class="col-lg-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              HOME
            </div>
          </a>
        </div>
      </div>      
    </div>
  </div>

  